const logger = require('@vietmeet/logger').getLogger('app:utils');
/**
 * Manages a queue of functions where the current function in progress will
 * automatically execute the next queued function.
 */
export class TaskQueue {
    /**
     * Creates a new instance of {@link TaskQueue} and sets initial instance
     * variable values.
     */
    constructor() {
        // @ts-ignore
        this._queue = [];
        // @ts-ignore
        this._currentTask = null;
        this._onTaskComplete = this._onTaskComplete.bind(this);
    }
    /**
     * Adds a new function to the queue. It will be immediately invoked if no
     * other functions are queued.
     *
     * @param {Function} taskFunction - The function to be queued for execution.
     * @private
     * @returns {void}
     */
    // @ts-ignore
    enqueue(taskFunction) {
        // @ts-ignore
        this._queue.push(taskFunction);
        this._executeNext();
    }
    /**
     * If no queued task is currently executing, invokes the first task in the
     * queue if any.
     *
     * @private
     * @returns {void}
     */
    _executeNext() {
        // @ts-ignore
        if (this._currentTask) {
            logger.warn('Task queued while a task is in progress.');
            return;
        }
        // @ts-ignore
        this._currentTask = this._queue.shift() || null;
        // @ts-ignore
        if (this._currentTask) {
            logger.debug('Executing a task.');
            try {
                // @ts-ignore
                this._currentTask(this._onTaskComplete);
            }
            catch (error) {
                logger.error(`Task execution failed: ${error}`);
                this._onTaskComplete();
            }
        }
    }
    /**
     * Prepares to invoke the next function in the queue.
     *
     * @private
     * @returns {void}
     */
    _onTaskComplete() {
        // @ts-ignore
        this._currentTask = null;
        logger.debug('Task completed.');
        this._executeNext();
    }
}
